import { FilterObject } from "@digicerba/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import {FiltreItem} from "app/pages/cerba/pages/catalogue-examens/filtres/vos-filtres/filtre-item";

@Component({
  selector: 'vos-filtres',
  templateUrl: './vos-filtres.component.html'
})
export class VosFiltresComponent {

  @Input() filtres: Array<FiltreItem>;
  @Output() onRemove: EventEmitter<FiltreItem> = new EventEmitter<FiltreItem>();

  constructor() {
  }

  remove(filtre: FiltreItem): void {
    this.onRemove.emit(filtre);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-examens/filtres/vos-filtres/vos-filtres.component.ts